"use client";
import { useState, useEffect } from "react";

//TODO: use this to conditionally render ScrollMessage for kiosk mode only once SiteWideOverlay is merged in

const useKioskMode = () => {
  const [isKiosk, setIsKiosk] = useState(false);

  useEffect(() => {
    const checkKioskMode = () => {
      const isStandalone =
        window.matchMedia("(display-mode: fullscreen)").matches ||
        window.navigator.standalone;
      const isLargeScreen =
        window.innerWidth >= 1920 && window.innerHeight >= 1080;
      const isTouchScreen = navigator.maxTouchPoints > 0;
      const isKioskUA = /kiosk|chromeos|touch/i.test(navigator.userAgent);
      const isMobile = /mobile/i.test(navigator.userAgent);

      setIsKiosk((isStandalone || isLargeScreen || isTouchScreen || isKioskUA) && !isMobile);
    };


    checkKioskMode();
    window.addEventListener("resize", checkKioskMode);
    return () => window.removeEventListener("resize", checkKioskMode);
  }, []);


  return isKiosk;
};

export default useKioskMode;
